import StethoscopeIcon from './StethoscopeIcon'

export default StethoscopeIcon
